import React from 'react';
import Particles from 'react-tsparticles';

import particlesConfig from '../config/particle-config';

const ParticlesBackground = () => {
    return (
        <Particles
            params={particlesConfig} />
    );
};

export default ParticlesBackground;